export default () => ({
  isOpen: false,
  isCandidateOpen: false,
  navigateCandidates() {
    this.isOpen = true;

    if (this.$store.router.id) {
      this.showCandidate();
    } else {
      this.closeCandidateDetail();
    }
  },
  backdropClose(e) {
    const { target } = e;

    if (target.classList.contains('Candidates-detail')) {
      this.$dispatch('navigate', '/clenove');
    }
  },
  closeCandidates() {
    this.isOpen = false;
  },
  showCandidate() {
    this.isCandidateOpen = true;
  },
  closeCandidateDetail() {
    this.isCandidateOpen = false;
  },
  checkActiveCandidate(slug) {
    return this.$store.router.id === slug;
  },
});
